import React, { useState } from 'react';
import '../styles/login.css';
import visibilityIcon from '../assets/visibility.png';
import HiddenIcon    from '../assets/hidden.png';
import loginimage    from '../assets/Login-amico.png';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer }    from 'react-toastify';
import { handleError, handleSuccess } from '../utils';
import { setAuthToken } from '../utils/auth';
import config from '../config/config';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';



export default function Login() {
  const [loginInfo, setLoginInfo] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();

  const togglePasswordVisibility = () =>
    setShowPassword(prev => !prev);


  function validatePassword(password) {
    const minLength = 8;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;
  
    if (password.length < minLength &&  !regex.test(password) ) {
      return (
        <p>
          1. Must be at least 8 characters long.<br /> 
          2. Must include uppercase, lowercase, number, and special character. 
        </p>
        
      );
    }
    if (!regex.test(password)) {
      return "Password must include uppercase, lowercase, number, and special character.";
    }
    if (password.length < minLength) {
      return "Must be at least 8 characters long.";
    }

    return "";
  }

  const handleChange = e => {
    const { name, value } = e.target;
    setLoginInfo(prev => ({ ...prev, [name]: value }));

    if (name === "password") {
      const error = validatePassword(value);
      setPasswordError(error);
    }
  };

  const handleLogin = async e => {
    e.preventDefault();
    const { email, password } = loginInfo;
    if (!email || !password) 
      return handleError('All fields are required');

    const error = validatePassword(password);
    if (error) {
    setPasswordError(error);
    return handleError('Password does not meet requirements');
    }


    try {
      const res = await fetch(`${config.apiUrl}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // This is important for cookies
        body: JSON.stringify(loginInfo)
      });
      const data = await res.json();
      const { success, message, jwToken, name, code, email: respEmail } = data;

      if (success) {
        handleSuccess(message);
        setAuthToken(jwToken);
        localStorage.setItem('loggedInUser', name);
        setTimeout(() => navigate('/'), 700);
      } else if (code === 'EMAIL_NOT_VERIFIED') {
        handleError('Email-Verification is required.');
        sessionStorage.setItem('pendingVerifyEmail', respEmail);
        setTimeout(() => {
          navigate('/verify-email', { state: { email: respEmail } });
        }, 2000); 
      } else {
        if (data.error) handleError(data.error.details[0].message);
        else handleError(message);
      }
    } catch (err) {
      handleError(err.message || err);
    } 
  };

  return (
    <div className='login-container'>
      <div className="form-box">
        <div className="form-left">
            <div className="toggle-buttons">
            <Link to="/login"  className="toggle active">Login</Link>
            <Link to="/signup" className="toggle">Signup</Link>
          </div>
          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type='email'
              name='email'
              placeholder='Enter your email'
              value={loginInfo.email}
              onChange={handleChange}
            />

            <label>Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                name='password'
                placeholder="Enter your password"
                className="password-input"
                value={loginInfo.password}
                onChange={handleChange}
              />
              <img
                src={showPassword ? visibilityIcon : HiddenIcon}
                alt="Toggle visibility"
                className="eye-icon"
                onClick={togglePasswordVisibility}
              />
              </div>
              {passwordError && <p className="error">{passwordError}</p>}
            

            <div className="action-row">
              <div className="remember">
                <input type="checkbox" id="remember" />
                <label htmlFor="remember">Remember me</label>
              </div>
              <button type="submit" className="submit-btn">
                Login
              </button>
            </div>

            <p
                className="forgot-password"
                onClick={() => alert('Redirect to reset password')}
              >
                Forgot Password?
              </p>
          

          <p className="switch-text">
            Not a member?{' '}
            <Link to='/signup' className="link">
              <span>Signup</span>
            </Link>
          </p>

          <div className="divider">
            <hr /><span>or</span><hr />
          </div>

          <p className="login-with">Login with</p>
          <div className="social-buttons">
            <GoogleLogin
              onSuccess={async (credentialResponse) => {
                try {
                  const token = credentialResponse.credential;
                  console.log("Google token from client:", token); // test JWT string

                  const res = await fetch(`${config.apiUrl}/api/auth/google-login`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({ token }),
                  });

                  const data = await res.json();

                  if (data.success) {
                    handleSuccess(data.message || 'Logged in with Google');
                    setAuthToken(data.jwToken);
                    localStorage.setItem('loggedInUser', data.name || 'GoogleUser');
                    navigate('/');
                  } else {
                    handleError(data.message || 'Google login failed');
                  }
                } catch (err) {
                  handleError(err.message || 'Google login error');
                }
              }}
              onError={() => {
                handleError('Google login failed');
              }}
            />

          </div>
          </form>
        </div>

        <div className="form-right" style={{
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  backgroundColor: '#f9f9f9',
  flex: 1,
  minWidth: '300px'
}}>
  <img
    src={loginimage}
    alt="Login Visual"
    style={{
      maxWidth: '100%',
      maxHeight: '400px',
      height: 'auto',
      width: 'auto',
      borderRadius: '12px'
    }}
  />
</div>

      </div>

      <ToastContainer />
    </div>
  );
}